import { Box, Grid, SkeletonLoader, Spacer } from "@alto-avios/alto-ui";

import { MAX_VISIBLE_BOOST_OPTIONS, SKELETON_ROW_HEIGHT } from "../../BalanceBoosterMultiplier.constants";

/** Loading placeholder; fixed rows, list may grow once options load. */
export const RewardPlatformBoosterUISkeleton = () => (
  <>
    <Box flexDirection={{ base: "column", xl: "row" }} gap={{ base: "2xl", xl: "xs" }}>
      <Grid columns={{ xl: 2 }}>
        <Box flexDirection="column" gap="2xs">
          <SkeletonLoader width={48} height={48} circle aria-label="Loading icon" />

          <Box flexDirection="column" gap="sm">
            <Box flexDirection="column" gap="5xs">
              <SkeletonLoader width="90%" height={SKELETON_ROW_HEIGHT.HEADING_MD} aria-label="Loading heading" />
              <SkeletonLoader width="40%" height={SKELETON_ROW_HEIGHT.HEADING_MD} aria-label="Loading heading" />
            </Box>
            <SkeletonLoader
              width="80%"
              height={SKELETON_ROW_HEIGHT.BODY_MD}
              count={2}
              aria-label="Loading description"
            />
          </Box>

          <SkeletonLoader width="60%" height={SKELETON_ROW_HEIGHT.BODY_SM} aria-label="Loading fine print" />
        </Box>

        <Box flexDirection="column" gap={{ base: "lg", lg: "sm" }}>
          <SkeletonLoader width="50%" height={SKELETON_ROW_HEIGHT.BODY_MD} aria-label="Loading section label" />

          <Box flexDirection="column" gap="xs">
            <SkeletonLoader
              width="100%"
              height={84}
              count={MAX_VISIBLE_BOOST_OPTIONS}
              elementFocusable
              aria-label="Loading boost options"
            />
          </Box>

          <Box justifyContent="end">
            <Spacer h="3xl" />
          </Box>
        </Box>
      </Grid>
    </Box>

    <SkeletonLoader
      width={180}
      height={SKELETON_ROW_HEIGHT.LABEL_MD}
      elementFocusable
      aria-label="Loading terms and conditions"
    />
  </>
);
